import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HelperFunctions } from 'src/app/util/util-functions';
import { JiraService } from '../../services/jira.service';
import { ModalService } from '../../services/modal.service';
import { ModalConfig } from '../modal/modal-config';

@Component({
  selector: 'app-create-jira-issue-form',
  templateUrl: './create-jira-issue-form.component.html',
  styleUrls: ['./create-jira-issue-form.component.scss'],
  standalone: false
})
export class CreateJiraIssueFormComponent {

  public modalConfig: ModalConfig;
  jiraIssueForm: FormGroup;
  isLoading = false;

  private jiraService = inject(JiraService);
  private modalService = inject(ModalService);
  private ngxUiLoaderService = inject(NgxUiLoaderService);

  constructor(private ngbActiveModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.modalConfig = {
      modalTitle: "Crear caso de soporte en Jira",
      ...this.modalConfig,
    };
    this.initForm();
  }

  close() {
    this.ngbActiveModal.close();
  }

  onSubmit() {
    if (this.jiraIssueForm.valid) {
      this.isLoading = true;
      this.ngxUiLoaderService.start('create-jira-issue-form');
      this.jiraService.createIssue(this.jiraIssueForm.value).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.ngxUiLoaderService.stop('create-jira-issue-form');
          this.modalService
            .getConfirmacionModal({
              message: `Caso de soporte creado con éxito en Jira. ID: ${response.id}`,
              confirmTitle: 'Aceptar'
            })
            .result.then(() => this.ngbActiveModal.close());
        },
        error: (error) => {
          this.isLoading = false;
          this.ngxUiLoaderService.stop('create-jira-issue-form');
          this.modalService.getConfirmacionModal({ message: error.error ? error.error?.message : 'Error en la creación del soporte', confirmTitle: 'Cerrar', isError: true })
        },
      });
    }
  }

  initForm(): void {
    this.jiraIssueForm = new FormGroup({
      summary: new FormControl('', [Validators.required, Validators.maxLength(255)]),
      description: new FormControl('', [Validators.required, Validators.maxLength(2000)])
    });
  }

  hasErrors(name: string): boolean {
    const control = this.jiraIssueForm.get(name) as FormControl;
    return HelperFunctions.controlIsInvalid(control);
  }
}
